import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { 
  getToken, 
  // getIsAdminLogin 
} from "./Utils/Common";

import './App.css';
import './CssFiles/CommonStyles/CommonStyles.css';
import './CssFiles/CustomStyles/CustomStyles.css';
import './CssFiles/Responsiveness/Responsiveness.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Property from "./Pages/Property/Property";

import RentalUnit from "./Pages/RentalUnit/RentalUnit";
import AddRentalUnit from "./Pages/RentalUnit/AddRentalUnit";
import ViewEditRentalUnit from "./Pages/RentalUnit/ViewEditRentalUnit";
import RentalUnitHistory from "./Pages/RentalUnit/RentalUnitHistory";

import Users from "./Pages/Users/Users";

import Tenants from "./Pages/Tenants/Tenants";
import AddTenants from "./Pages/Tenants/AddTenants";
import RenewTenants from "./Pages/Tenants/RenewTenants";
import EditTenantRate from "./Pages/Tenants/EditTenantRate";
import EditViewTenants from "./Pages/Tenants/EditViewTenants";
import TenantHistory from "./Pages/Tenants/TenantHistory";
import MoveOutTenants from "./Pages/Tenants/MoveOutTenants";
import DebitSOA from "./Pages/Tenants/DebitSOA";

import Owner from "./Pages/Owner/Owner";
import AddOwner from "./Pages/Owner/AddEditOwner";

import SecurityDesposits from "./Pages/SecurityDeposits/SecurityDesposits";

import AdvanceRental from "./Pages/Advance Rental/AdvanceRental";

import ConstructionBond from "./Pages/Construction Bonds/ConstructionBond";

import ElectricityMeterReadings from "./Pages/Meter Readings/ElectricityMeterReadings";
import GasMeterReading from "./Pages/Meter Readings/GasMeterReading";
import WaterMeterReading from "./Pages/Meter Readings/WaterMeterReading";
import ViewReading from "./Pages/Meter Readings/ViewReading";
import AddReading from "./Pages/Meter Readings/AddReading";

import Billing from "./Pages/Billings/Billing";
import OwnerBilling from "./Pages/Billings/OwnerBilling";
import AddBilling from "./Pages/Billings/AddBilling";
import BillingItems from "./Pages/Billings/BillingItems";
import DiscountItems from "./Pages/Billings/DiscountItems";
import PreviewBilling from "./Pages/Billings/PreviewBilling";

import Payments from "./Pages/Payments/Payments";
import OwnerPayment from "./Pages/Payments/OwnerPayment";
import AddPayment from "./Pages/Payments/AddPayment";
import PreviewPayment from "./Pages/Payments/PreviewPayment";

import Suppliers from "./Pages/Suppliers/Suppliers";

import MonthlyCollection from "./Pages/TenantReports/MonthlyCollection";
import MonthlyPayment from "./Pages/TenantReports/MonthlyPayment";
import ReceivableReport from "./Pages/TenantReports/ReceivableReport";
import MonthlyOwnerIncome from "./Pages/TenantReports/MonthlyOwnerIncome";
import MonthlyManagementIncome from "./Pages/TenantReports/MonthlyManagementIncome";
import PreviewOwnerIncome from "./Pages/TenantReports/PreviewOwnerIncome";

import Exhibitors from "./Pages/Exhibitors/Exhibitors";
import AddExhibitors from "./Pages/Exhibitors/AddExhibitors";
import EditViewExhibitors from "./Pages/Exhibitors/EditViewExhibitors";
import ExhibitorsBilling from "./Pages/Exhibitors/ExhibitorsBilling";
import AddExhibitorsBilling from "./Pages/Exhibitors/AddExhibitorsBilling";
import EditViewExhibitorsBilling from "./Pages/Exhibitors/EditViewExhibitorsBilling";
import PrintPreviewExhibitorsBilling from "./Pages/Exhibitors/PrintPreviewExhibitorsBilling";
import ExhibitorsPayment from "./Pages/Exhibitors/ExhibitorsPayment";
import AddExhibitorsPayment from "./Pages/Exhibitors/AddExhibitorsPayment";
import PrintPreviewExhibitorsPayment from "./Pages/Exhibitors/PrintPreviewExhibitorsPayment";

import Expense from "./Pages/Expense/Expense";
import AddExpense from "./Pages/Expense/AddExpense";
import EditExpense from "./Pages/Expense/EditExpense";
import PreviewExpense from "./Pages/Expense/PreviewExpense";
import ViewExpense from "./Pages/Expense/ViewExpense";

import ExhibitorPaymentReport from "./Pages/Reports/ExhibitorPaymentReport";
import ExhibitorReceivableReport from "./Pages/Reports/ExhibitorReceivableReport";

import { Toaster } from 'react-hot-toast';
function App() {
  const userToken = getToken();
  // const isAdmin = getIsAdminLogin();

  const toastOptions = {
    duration: 3000,
    style: {
      fontFamily: 'var(--font-regular)',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.9)', 
      color: '#fff', 
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out', 
    },
    success: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(65, 184, 131, 0.9)', 
      },
    },
    error: {
      style: { 
        textTransform: 'capitalize',
        backgroundColor: 'rgba(255, 99, 71, 0.9)', 
      },
    },
  };
  
  
  
  return (
    <div className="page">
      <Toaster position="top-right" toastOptions={toastOptions} />
      <Router>
        <Routes>
          <Route path="/" element={userToken ? <Dashboard/> : <Login/>} />
          {/* <Route path="/login" element={<Login/>} /> */}
          <Route path="/dashboard" element={userToken ? <Dashboard /> : <Login />} /> {/* Line added by Gab */}
          <Route path="/property" element={userToken ? <Property/> : <Login/>} />

          <Route path="/rental-unit" element={userToken ? <RentalUnit/> : <Login/>} />
          <Route path="/rental-unit/add" element={userToken ? <AddRentalUnit/> : <Login/>} />
          <Route path="/rental-unit/edit/:id" element={userToken ? <ViewEditRentalUnit/> : <Login/>} />
          <Route path="/rental-unit/history" element={userToken ? <RentalUnitHistory/> : <Login/>} />

          <Route path="/tenant" element={userToken ? <Tenants /> : <Login/>} />
          <Route path="/tenant/move-out/:id" element={userToken ? <MoveOutTenants /> : <Login/>} />
          <Route path="/tenant/add" element={userToken ? <AddTenants /> : <Login/>} />
          <Route path="/tenant/rate/:id" element={userToken ? <EditTenantRate /> : <Login/>} />
          <Route path="/tenant/renew/:id" element={userToken ? <RenewTenants /> : <Login/>} />
          <Route path="/tenant/edit/:id" element={userToken ? <EditViewTenants /> : <Login/>} />
          <Route path="/tenant/history/:id" element={userToken ? <TenantHistory /> : <Login/>} />
          <Route path="/tenant/print-soa/:type/:id" element={userToken ? <DebitSOA /> : <Login/>} />

          <Route path="/owner" element={userToken ? <Owner /> : <Login/>} />
          <Route path="/owner/add" element={userToken ? <AddOwner /> : <Login/>} />
          <Route path="/owner/edit/:id" element={userToken ? <AddOwner /> : <Login/>} />

          <Route path="/security-deposit" element={userToken ? <SecurityDesposits /> : <Login/>} />

          <Route path="/advance-rental" element={userToken ? <AdvanceRental /> : <Login/>} />

          <Route path="/construction-bond" element={userToken ? <ConstructionBond /> : <Login/>} />

          <Route path="/electric-reading" element={userToken ? <ElectricityMeterReadings /> : <Login/>} />
          <Route path="/gas-reading" element={userToken ? <GasMeterReading /> : <Login/>} />
          <Route path="/water-reading" element={userToken ? <WaterMeterReading /> : <Login/>} />
          <Route path="/view-reading/:type/:id" element={userToken ? <ViewReading /> : <Login/>} />
          <Route path="/add-reading/:type" element={userToken ? <AddReading /> : <Login/>} />

          <Route path="/billing" element={userToken ? <Billing /> : <Login/>} />
          <Route path="/owner-billing" element={userToken ? <OwnerBilling /> : <Login/>} />
          <Route path="/add-billing/:type" element={userToken ? <AddBilling /> : <Login/>} />
          <Route path="/billing-item" element={userToken ? <BillingItems /> : <Login/>} />
          <Route path="/discount-item" element={userToken ? <DiscountItems /> : <Login/>} />
          <Route path="/preview-billing/:type/:id" element={userToken ? <PreviewBilling /> : <Login/>} />

          <Route path="/tenant-payment" element={userToken ? <Payments /> : <Login/>} />
          <Route path="/owner-payment" element={userToken ? <OwnerPayment /> : <Login/>} />
          <Route path="/add-payment/:type" element={userToken ? <AddPayment /> : <Login/>} />
          <Route path="/preview-payment/:type/:id" element={userToken ? <PreviewPayment /> : <Login/>} />

          <Route path="/supplier" element={userToken ? <Suppliers /> : <Login/>} />

          <Route path="/monthly-collection" element={userToken ? <MonthlyCollection /> : <Login/>} />
          <Route path="/monthly-payment" element={userToken ? <MonthlyPayment /> : <Login/>} />
          <Route path="/receivable-report" element={userToken ? <ReceivableReport /> : <Login/>} />
          <Route path="/owner-income" element={userToken ? <MonthlyOwnerIncome /> : <Login/>} />
          <Route path="/management-income" element={userToken ? <MonthlyManagementIncome /> : <Login/>} />
          <Route path="/owner-income/preview/:id" element={userToken ? <PreviewOwnerIncome /> : <Login/>} />

          <Route path="/exhibitor" element={userToken ? <Exhibitors /> : <Login/>} />
          <Route path="/add-exhibitor" element={userToken ? <AddExhibitors /> : <Login/>} />
          <Route path="/edit-exhibitor" element={userToken ? <EditViewExhibitors /> : <Login/>} />
          <Route path="/exhibitor-billing" element={userToken ? <ExhibitorsBilling /> : <Login/>} />
          <Route path="/add-exhibitor-billing" element={userToken ? <AddExhibitorsBilling /> : <Login/>} />
          <Route path="/edit-exhibitor-billing" element={userToken ? <EditViewExhibitorsBilling /> : <Login/>} />
          <Route path="/preview-exhibitor-billing" element={userToken ? <PrintPreviewExhibitorsBilling /> : <Login/>} />
          <Route path="/exhibitor-payment" element={userToken ? <ExhibitorsPayment /> : <Login/>} />
          <Route path="/add-exhibitor-payment" element={userToken ? <AddExhibitorsPayment /> : <Login/>} />
          <Route path="/preview-exhibitor-payment" element={userToken ? <PrintPreviewExhibitorsPayment /> : <Login/>} />

          <Route path="/expense" element={userToken ? <Expense /> : <Login/>} />
          <Route path="/expense/view/:id" element={userToken ? <ViewExpense /> : <Login/>} />
          <Route path="/expense/preview/:id" element={userToken ? <PreviewExpense /> : <Login/>} />
          <Route path="/add-expense" element={userToken ? <AddExpense /> : <Login/>} />
          <Route path="/edit-expense/:id" element={userToken ? <EditExpense /> : <Login/>} />

          <Route path="/exhibitor-payment-report" element={userToken ? <ExhibitorPaymentReport /> : <Login/>} />
          <Route path="/exhibitor-receivable-report" element={userToken ? <ExhibitorReceivableReport /> : <Login/>} />

          <Route path="/user" element={userToken ? <Users/> : <Login/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
